import { Link } from "react-router-dom";

import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";

function TimeOff(){  
    return <>
        <div className="TimeOffs">

            {/* <div className="cardHeading"><h2>In TimeOff</h2></div>  */}
       
        <div className="MainCard"> 

            <div className="mainCardTop">

                <div className="miniCardContainer">

                    <div className="HalfCard">
                        <div className="AbHeading"> <h2>Request</h2></div>
                        <div className="abItems">
                            <ul> 
                                <li> <Link className="linkItem" to={"/Dashboard/PTOReports"}><p>{"Request Absence"}</p> </Link></li>
                                <li> Correct My Absence</li>
                                <li> Request Return rom Leave</li>
                            </ul>
                        </div>
                    </div>

            </div>

                    <div className="miniCardContainer">

                            <div className="HalfCard">
                                <div className="AbHeading"> <h2>View</h2></div>
                                <div className="abItems">
                                    <ul> 
                                        <li> <Link className="linkItem" to={"/Dashboard/PTORequest"}><p>{"Leave Requests"}</p> </Link></li>
                                        {/* <li> Leave Request Forms</li> */}
                                        <li> My Absence</li>
                                        <li> Absence Balance</li>
                                    </ul>
                                </div>
                            </div>

                    </div>

            </div>
            

                    

           
          
            <div className="SummaryCard">
                <div className="AbHeading"> <h2>View</h2></div>
                <div className="AbSHeading"> <p>Does not include Absence requests</p></div>
                <div>
                <tbody>
                            <tr>
                                 <td>02/08/2022</td>
                            </tr>
                            <tr>
                                 <td>02/08/2022</td>
                            </tr>
                            <tr>
                                 <td>02/08/2022</td>
                            </tr>
                         
                        </tbody>
                    
                 </div>

            </div>

        </div>

        </div>
        
        
    
    </>

}

export default TimeOff;